/**
 * Central frontend config.
 *
 * API_BASE is the backend origin (no trailing /api). In production set
 * REACT_APP_API_URL (e.g. https://veritas-api.fly.dev). Defaults to localhost
 * for dev. Keep this in sync with src/services/api.ts, which appends /api.
 */
export const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8000';

/**
 * localStorage key for the JWT. The whole app (AuthContext) stores the token
 * under 'token' — use this constant everywhere so pages don't drift onto a
 * different key and silently send unauthenticated requests.
 */
export const TOKEN_KEY = 'token';

export const getToken = (): string | null => localStorage.getItem(TOKEN_KEY);
